module.exports = __webpack_public_path__ + "img/Kuwait-landscape-english.32f3415b.jpg";